import { useLocation } from 'react-router-dom';
import { exportToCSV } from '../utils/csvExportUtil';

const useExportCSV = (fetchData, fileName) => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const queryParams = {};
    searchParams.forEach((value, key) => {
        queryParams[key] = value;
    });

    const handleExportCSV = async () => {
        exportToCSV(await fetchData(-1, queryParams), fileName + '.csv');
    };

    return { handleExportCSV };
};

export default useExportCSV;
